<template>
  <div class="gula_view">
    <el-dialog :close-on-click-modal="false" :title="getAsync()" :visible.sync="showLogin" width="30%"
               :before-close="closeLogin">
      <el-form v-if="showPasswordLogin != 3 && showPasswordLogin != 4" :label-position="labelPosition"
               :rules="loginRules"
               :model="loginForm" ref="loginForm">
        <div class="passwordLogin">
          <el-form-item prop="userName" v-if="showPasswordLogin == 1">
            <el-input v-model="loginForm.userName" placeholder="请输入用户名或邮箱"
                      :disabled="loginType.password"></el-input>
          </el-form-item>
          <el-form-item prop="password" v-if="showPasswordLogin == 1">
            <div class="div_view">
              <el-input type="password" v-model="loginForm.password" placeholder="请输入密码"
                        :disabled="loginType.password"></el-input>
              <div @click="onClickForget" class="div_ab">忘记密码</div>
            </div>
          </el-form-item>

          <el-form-item prop="mobile" v-if="showPasswordLogin == 2">
            <div>
              <el-input v-model="loginForm.mobile" maxlength="11" placeholder="请输入手机号"
                        :disabled="loginType.password"></el-input>
            </div>
          </el-form-item>

          <el-form-item prop="imageCode" v-if="showPasswordLogin == 2">
            <div class="div_view">
              <el-input v-model="loginForm.imageCode" placeholder="请输入图片验证码"></el-input>
              <img
                @click="getImage"
                v-if="imageUrl"
                class="div_ab"
                style="width: 100px;height: 40px;top: -10px"
                :src="imageUrl"
                alt="">
              <div @click="getImage" class="div_ab" v-if="!imageUrl">刷新</div>
            </div>
          </el-form-item>

          <el-form-item v-if="showPasswordLogin == 2">
            <div class="div_view">
              <el-input v-model="loginForm.smsCode" placeholder="请输入验证码"></el-input>
              <div v-show="show" @click="onCLickCode(1)" class="div_ab">获取验证码</div>
              <div v-show="!show" class="div_ab">{{ count }} s</div>
            </div>
          </el-form-item>


          <el-row class="btn">
            <el-button class="loginBtn" type="primary" @click="startLogin"
                       :disabled="loginType.password">登录/注册
            </el-button>
            <!-- <el-button class="registerBtn" type="info" @click="goRegister" :disabled="loginType.password">注册</el-button> -->
          </el-row>
        </div>

        <div class="wrapper_flex">
          <div class="wrapper_li">
            <div>其它方式：</div>
            <el-row class="elRow">
              <!-- <el-tooltip content="QQ" placement="bottom">
            <el-button type="primary" circle @click="goAuth('qq')" :disabled="loginType.qq">
              <span class="iconfont">&#xe601;</span>
            </el-button>
          </el-tooltip> -->
              <el-tooltip content="微信" placement="bottom">
                <el-button type="success" circle @click="goAuth('wechat')" :disabled="loginType.wechat">
                  <span size="20px" class="iconfont">&#xe66f;</span>
                </el-button>
                <!-- <el-button type="danger" icon="el-icon-delete" circle></el-button> -->
              </el-tooltip>
            </el-row>
          </div>

          <div v-show="showPasswordLogin == 1" @click="onClickRight(2)" class="wrapper_text">验证码登录</div>
          <div v-show="showPasswordLogin == 2" @click="onClickRight(1)" class="wrapper_text">密码登录</div>
        </div>
        <div class="wrapper_tips">登录即代表你同意 <span @click="onClickUser" style="color: #0083FC;cursor: pointer;">用户协议</span>
        </div>
      </el-form>

      <div class="wrapper_code_view" v-if="showPasswordLogin == 3">
        <div class="wrapper_code_top">
          <!-- <img src="" alt=""> -->
          <div class="title">使用微信扫一扫登录</div>
        </div>
        <div class="wrapper_cont_top">「商用车界」</div>
        <div class="wrapper_wrapper_cont_img">
          <img style="width: 100%;height: 100%;" :src="wechatOrCode" alt="">
          <div @click="refreshWechatCode" v-if="wechatOrCodeText" class="title">{{ wechatOrCodeText }}</div>
        </div>

        <div @click="showPasswordLogin = 1" class="wrapper_cont_top_tips">密码登录</div>
      </div>


      <div v-if="showPasswordLogin == 4">
        <div class="passwordLogin">
          <div>密码必须包括数字和英文字母，长度6-20位</div>
          <el-form :label-position="labelPosition" :rules="loginRules" :model="loginForm" ref="loginForm">
            <el-form-item prop="mobile">
              <el-input v-model="loginForm.mobile" placeholder="请输入手机号" :disabled="loginType.password"></el-input>
            </el-form-item>

            <el-form-item prop="password">
              <div class="div_view">
                <el-input type="password" v-model="loginForm.password" placeholder="请输入密码"
                          :disabled="loginType.password"
                          show-password></el-input>
              </div>
            </el-form-item>

            <el-form-item prop="passwordTow">
              <div class="div_view">
                <el-input type="password" v-model="loginForm.passwordTow" placeholder="请确认密码"
                          :disabled="loginType.password" show-password></el-input>
              </div>
            </el-form-item>


            <el-form-item prop="imageCode">
              <div class="div_view">
                {{ imageUrl }}
                <el-input v-model="loginForm.imageCode" placeholder="请输入图片验证码"></el-input>

                <img
                  @click="getImage"
                  v-if="imageUrl"
                  class="div_ab"
                  style="width: 100px;height: 40px;top: -10px"
                  :src="imageUrl"
                  alt="">
                <div @click="getImage" class="div_ab" v-if="!imageUrl">刷新</div>
              </div>
            </el-form-item>


            <el-form-item>
              <div class="div_view">
                <el-input v-model="loginForm.smsCode" placeholder="请输入验证码"></el-input>
                <div v-show="show" @click="onCLickCode" class="div_ab">获取验证码</div>
                <div v-show="!show" class="div_ab">{{ count }} s</div>
              </div>
            </el-form-item>


            <el-row class="btn">
              <el-button class="loginBtn" type="primary" @click="startLoginAsync"
                         :disabled="loginType.password">提交
              </el-button>
            </el-row>

            <div @click="onClickRightCode" class="wrapper_code_login">验证码登录</div>
          </el-form>
        </div>
      </div>
    </el-dialog>


    <el-dialog :before-close="closeLoginMobile" :close-on-click-modal="false" title="新用户注册，绑定手机号码"
               :visible.sync="showMobile" width="30%">
      <el-form :label-position="labelPosition" :rules="loginRules" :model="showMobileObj" ref="showMobileObj">
        <div class="passwordLogin">
          <el-form-item prop="mobile">
            <el-input v-model="showMobileObj.mobile" placeholder="请输入手机号"
                      :disabled="loginType.password"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="div_view">
              <el-input v-model="showMobileObj.smsCode" placeholder="请输入验证码"></el-input>
              <div v-show="show" @click="onCLickCodeMobile" class="div_ab">获取验证码</div>
              <div v-show="!show" class="div_ab">{{ count }} s</div>
            </div>
          </el-form-item>
          <el-row class="btn">
            <el-button class="loginBtn" type="primary" @click="startLoginMobile"
                       :disabled="loginType.password">绑定
            </el-button>
          </el-row>
        </div>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import {
  login,
  localLogin,
  localRegister,
  getWechatOrCodeTicket,
  getUserLoginStatus,
  loginsendSms,
  loginByTel,
  loginResetPasswordBySms,
  loginGetImageVC
} from '@/api/user'
import {Loading} from 'element-ui'
import {setCookie} from '@/utils/cookieUtils'
import {mapMutations} from 'vuex'

export default {
  name: 'share',
  data () {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.loginForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      timer: false,
      count: '',
      show: true,
      loading: null,
      option: {
        fullscreen: true,
        lock: true
      },
      vueMoguWebUrl: process.env.VUE_MOGU_WEB,
      showPasswordLogin: '2', // 是否显示账号密码登录
      wechatOrCode: '', // 微信公众号登录二维码
      ticket: '', // 用户的票券
      // 显示登录页面
      showLogin: true,
      isLogin: false,
      table: false,
      dialog: false,
      labelPosition: 'right',
      loginForm: {
        imageCode: '',
        userName: '',
        password: ''
      },
      registerForm: {
        userName: '',
        password: '',
        password2: '',
        email: ''
      },
      // 登录类别
      loginType: {
        password: true,
        gitee: true,
        github: true,
        qq: true,
        wechat: true
      },
      loginRules: {
        userName: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
          {min: 5, message: '用户名长度大于等于 5 个字符', trigger: 'blur'},
          {max: 20, message: '用户名长度不能大于 20 个字符', trigger: 'blur'}
        ],
        nickName: [
          {required: true, message: '请输入昵称', trigger: 'blur'},
          {min: 1, message: '用户名长度大于等于 1 个字符', trigger: 'blur'},
          {max: 20, message: '用户名长度不能大于 20 个字符', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 5, message: '密码长度需要大于等于 5 个字符', trigger: 'blur'},
          {max: 20, message: '密码长度不能大于 20 个字符', trigger: 'blur'}
        ],
        passwordTow: [
          {validator: validatePass2, trigger: 'blur'}
        ],
        mobile: [
          {required: true, message: '手机号不能为空', trigger: 'blur'},
          {
            pattern: /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
            message: '请输入正确的手机号'
          },
        ],
        smsCode: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
        ],
        imageCode: [
          {required: true, message: '请输入图片验证码', trigger: 'blur'},
        ],
      },
      wechatOrCodeText: '',
      showMobile: false,
      showMobileObj: {},
      imageUrl: '',
      imageCode: '',
      imageId: '',
    }
  },
  components: {},
  created () {
    this.getImage()
    this.setLoginTypeList()
  },
  methods: {
    ...mapMutations(['setUserInfo', 'setLoginState']),
    setLoginTypeList: function () {
      // 获取登录方式列表
      let webConfigData = this.$store.state.app.webConfigData
      if (webConfigData.loginTypeList != undefined) {
        let loginTypeList = JSON.parse(webConfigData.loginTypeList)
        for (let a = 0; a < loginTypeList.length; a++) {
          switch (loginTypeList[a]) {
            case '1': {
              this.loginType.password = false
            }
              break
            case '2': {
              this.loginType.gitee = false
            }
              break
            case '3': {
              this.loginType.github = false
            }
              break
            case '4': {
              this.loginType.qq = false
            }
              break
            case '5': {
              this.loginType.wechat = false
            }
              break
            default: {
              console.log('登录方式设置有误！！')
            }
          }
        }
      }
    },
    onClickRight (data) {
      console.log(data)
      if (data == 2) {
        this.$refs['loginForm'].resetFields()
        this.$set(this.loginForm, 'mobile', '')
        this.$set(this.loginForm, 'smsCode', '')
        this.getImage()
      } else {
        this.$set(this.loginForm, 'userName', '')
        this.$set(this.loginForm, 'password', '')
      }
      // console.log(this.$refs['loginForm'])
      this.showPasswordLogin = data
    },
    //
    onClickRightCode () {
      this.showPasswordLogin = 2
      this.loginForm.smsCode = ''
      this.$refs['loginForm'].resetFields()
      this.getImage()
    },
    onCLickCode () {
      const TIME_COUNT = 60
      console.log(this.timer)
      if (!this.timer) {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            let obj = {
              mobile: this.loginForm.mobile,
              imgCode: this.loginForm.imageCode,
              recordId: this.imageId,
            }
            loginsendSms(obj).then(response => {
              console.log(response)
              if (response.code == 'error') return this.$message({type: 'error', message: response.data})

              if (response.code == this.$ECode.SUCCESS) {
                if (response.data != '发送成功') return this.$message({type: 'error', message: response.data})
                this.$message({type: 'success', message: '发送成功'})
                this.count = TIME_COUNT
                this.show = false
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count -= 1
                  } else {
                    this.show = true
                    clearInterval(this.timer)
                    this.timer = false
                  }
                }, 1000)
              }
            })
          }
        })
      }
    },
    startLogin: function () {
      if (this.showPasswordLogin == 1) {
        this.$refs.loginForm.validate((valid) => {
          console.log('开始校验', valid)
          if (!valid) {
            console.log('校验失败')
            return
          } else {
            var params = {}
            params.userName = this.loginForm.userName
            params.passWord = this.loginForm.password
            params.isRememberMe = 1
            localLogin(params).then(response => {
              if (response.code == this.$ECode.SUCCESS) {
                localStorage.setItem('token', response.data)
                // 跳转到首页
                location.replace(this.vueMoguWebUrl + '/#/?token=' + response.data)
                window.location.reload()
              } else {
                this.$message({
                  type: 'error',
                  message: response.data
                })
              }
            })
          }
        })
      } else {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            if (!this.loginForm.smsCode) {
              return this.$message({
                type: 'error',
                message: '请输入验证码'
              })
            }
            //    post请求，参数：，
            let obj = {
              mobile: this.loginForm.mobile,
              smsCode: this.loginForm.smsCode
            }
            loginByTel(obj).then((response) => {
              console.log(response)
              if (response.code == this.$ECode.SUCCESS) {
                localStorage.setItem('token', response.data)
                // 跳转到首页
                location.replace(this.vueMoguWebUrl + '/#/?token=' + response.data)
                window.location.reload()
              } else {
                this.$message({
                  type: 'error',
                  message: response.data
                })
              }
            })
          }
        })
      }
    },

    startLoginMobile () {
      this.$refs.showMobileObj.validate((valid) => {
        if (valid) {
          if (!this.showMobileObj.smsCode) {
            return this.$message({
              type: 'error',
              message: '请输入验证码'
            })
          }
          var params = {}
          params.source = this.showMobileObj.source
          params.uuid = this.showMobileObj.uuid
          params.nickName = this.showMobileObj.nickName
          params.userName = this.showMobileObj.userName
          params.startEmailNotification = this.showMobileObj.startEmailNotification
          params.validCode = this.showMobileObj.validCode
          params.smsCode = this.showMobileObj.smsCode
          params.mobile = this.showMobileObj.mobile

          loginByTel(params).then((response) => {
            console.log(response)
            if (response.code == this.$ECode.SUCCESS) {
              localStorage.setItem('token', response.data)
              // 跳转到首页
              location.replace(this.vueMoguWebUrl + '/#/?token=' + response.data)
              window.location.reload()
            } else {
              this.$message({
                type: 'error',
                message: response.data
              })
            }
          })
        }
      })
    },

    onCLickCodeMobile () {
      const TIME_COUNT = 60
      if (!this.timer) {
        this.$refs.showMobileObj.validate((valid) => {
          if (valid) {
            let obj = {
              mobile: this.showMobileObj.mobile
            }
            loginsendSms(obj).then(response => {
              if (response.code == this.$ECode.SUCCESS) {
                if (response.data != '发送成功') return this.$message({type: 'error', message: response.data})
                this.$message({type: 'success', message: '发送成功'})
                this.count = TIME_COUNT
                this.show = false
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count -= 1
                  } else {
                    this.show = true
                    clearInterval(this.timer)
                    this.timer = null
                  }
                }, 1000)
              }
            })
          }
        })
      }
    },

    startLoginAsync () {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          if (!this.loginForm.smsCode) {
            return this.$message({
              type: 'error',
              message: '请输入验证码'
            })
          }
          //    post请求，参数：，
          let obj = {
            mobile: this.loginForm.mobile,
            passWord: this.loginForm.password,
            smsCode: this.loginForm.smsCode
          }
          loginResetPasswordBySms(obj).then((response) => {
            console.log(response)

            if (response.code == this.$ECode.SUCCESS) {
              this.$message({
                type: 'success',
                message: '重置成功'
              })
              this.onClickRight(1)
              this.loginForm.password = ''
              this.loginForm.smsCode = ''
            } else {
              this.$message({
                type: 'error',
                message: response.data
              })
            }
          })
        }
      })

    },
    startRegister: function () {
      this.$refs.registerForm.validate((valid) => {
        if (!valid) {
          console.log('校验失败')
          return
        } else {
          let passWord = this.registerForm.password
          let passWord2 = this.registerForm.password2
          if (passWord != passWord2) {
            this.$message({
              type: 'success',
              message: '两次密码不一致'
            })
            return
          }
          var params = {}
          params.userName = this.registerForm.userName
          params.passWord = this.registerForm.password
          params.email = this.registerForm.email
          params.nickName = this.registerForm.nickName
          localRegister(params).then(response => {
            if (response.code == this.$ECode.SUCCESS) {
              this.$message({
                type: 'success',
                message: response.data
              })
              // 打开登录页面
              this.goLogin()
            } else {
              this.$message({
                type: 'error',
                message: response.data
              })
            }
          })
        }
      })
    },
    goLogin: function () {
      this.showLogin = true
    },
    goRegister: function () {
      this.registerForm.userName = ''
      this.registerForm.password = ''
      this.registerForm.password2 = ''
      this.registerForm.email = ''
      this.showLogin = false
    },
    userInfoStatus: function () {
      getUserLoginStatus().then(response => {
        console.log('获取用户状态', response)
      })
    },
    // 刷新微信二维码
    refreshWechatCode: function () {

      let that = this
      getWechatOrCodeTicket().then(response => {
        if (response.code == this.$ECode.SUCCESS) {
          console.log('得到的响应', response)
          this.showPasswordLogin = '3'
          let data = response.data
          let ticket = data.ticket
          this.wechatOrCodeText = ''
          this.wechatOrCode = 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + ticket
          this.ticket = ticket
          let count = 0
          let interval = setInterval(() => {
            count++
            // 当检查5次未扫码的时候，将二维码失效，重试关闭接口请求
            if (count > 5) {
              this.wechatOrCodeText = '二维码已经失效，请点击刷新',
                clearInterval(interval)
            }
            let params = new URLSearchParams()
            params.append('ticket', ticket)
            getUserLoginStatus(params).then(response => {
              console.log('获取用户状态', response)
              if (response.code == that.$ECode.SUCCESS) {
                if (response.data.mobile) {
                  let token = ticket
                  // 判断url中是否含有token    // 设置token七天过期
                  if (token != undefined) setCookie('token', token, 7)
                  this.setUserInfo(response.data)
                  this.setLoginState(true)
                  window.location.reload()
                } else {
                  clearInterval(interval)
                  //扫码数据
                  this.showLogin = false
                  this.showMobile = true
                  this.showMobileObj = response.data
                }
              }
            })
          }, 3000)

        } else {
          this.$message.error(response.message)
        }
      })
    },
    goAuth: function (source) {
      console.log('我点了微信')
      console.log(this.$route.path)
      let url = window.parent.location.href
      console.log(url + '')
      // if (haveToken != -1) {
      //   let list = url.split("?token");
      //   this.isLogin = false;
      //   window.location.href = list[0]
      //   let userInfo = {};
      //   this.setUserInfo(userInfo)
      // } else {

      // }

      // 记录跳转地址，后续登录后做跳转到此页面
      // if (this.$route.path == '/info') {
      //   setCookie('redirectUrl', this.$route.path + '?uid=' + this.$route.query.uid, 1)
      // } else {
      //   setCookie('redirectUrl', this.$route.path, 1)
      // }
      // 判断是否点击公众号登录
      if (source == 'wechat') {
        console.log('点击公众号登录')
        this.refreshWechatCode()
        return
      }
      this.loading = Loading.service({
        lock: true,
        text: '加载中……',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      var params = new URLSearchParams()
      params.append('source', source)
      login(params).then(response => {
        if (response.code == this.$ECode.SUCCESS) {
          var token = response.data.token
          window.location.href = response.data.url
        }
      })
    },
    closeLogin: function () {
      this.$emit('closeLoginBox', '')
    },
    closeLoginMobile () {
      this.showLogin = true
      this.$emit('closeLoginBox', '')
    },

    onClickUser () {
      let routeData = this.$router.resolve({
        path: '/treaty',
        query: {blogOid: '3'}
      })
      window.open(routeData.href, '_blank')
    },

    // 点击忘记密码
    onClickForget () {
      this.onClickRight(1)
      this.getImage()
      this.loginForm.password = ''
      this.loginForm.smsCode = ''
      this.showPasswordLogin = 4
    },
    getAsync () {
      if (this.showPasswordLogin == 1) return '密码登录'
      if (this.showPasswordLogin == 2) return '验证码登录'
      if (this.showPasswordLogin == 4) return '忘记密码'
    },

    async getImage () {
      const res = await loginGetImageVC()
      this.imageUrl = res.content.image
      this.imageId = res.content.recordId
    },
  }
}
</script>


<style>
.passwordLogin .box {
  width: 400px;
  height: 420px;
  background: white;
  position: fixed;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 101;
  /* 要比遮罩层大 */
}

.passwordLogin .registerBox {
  height: 660px;
}

.passwordLogin .box .title {
  height: 48px;
  font-size: 22px;
  font-weight: bold;
  text-align: center;
  line-height: 48px;
}

.passwordLogin .box .title .t2 {
  font-size: 16px;
  float: right;
  margin-right: 6px;
  margin-top: -6px;
  cursor: pointer;
}

.passwordLogin .box .el-divider--horizontal {
  margin: 12px 0;
}

.passwordLogin .box .el-form-item__label {
  margin-left: 10px;
  font-size: 16px;
}

.passwordLogin .box .el-input__inner {
  margin-left: 10px;
  width: 90%;
  padding: 0 !important;
}

.passwordLogin .box .btn {
  text-align: center;
}

.passwordLogin .btn .loginBtn {
  width: 100%;
}

.passwordLogin .box .registerBtn {
  width: 40%;
}

.passwordLogin .elRow {
  /* margin-top: 15px; */
  text-align: center;
}

.passwordLogin .loginTip {
  margin-top: 10px;
  font-size: 14px;
  text-align: center;
  color: #bababa;
}

.passwordLogin .remarksBox {
  position: fixed;
  left: 50%;
  margin-left: -100px;
  top: 50%;
  margin-top: -50px;
  border: 1px solid red;
  width: 200px;
  height: 100px;
  text-align: center;
  z-index: 101;
  /* 要比遮罩层大 */
}

/* 遮罩层 */
.passwordLogin .mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
}

.passwordLogin .el-input__inner {
  border: none;
}

.passwordLogin .el-input {
  font-size: 16px;
}


.passwordLogin .el-input > input {
  border: none;
  border-bottom: 1px solid #C2C2C2;
  border-radius: 0;
  padding: 0;
}

.passwordLogin .el-form-item.is-error .el-input__inner,
.passwordLogin .el-form-item.is-error .el-input__inner:focus,
.passwordLogin .el-form-item.is-error .el-textarea__inner,
.passwordLogin .el-form-item.is-error .el-textarea__inner:focus,
.passwordLogin .el-message-box__input input.invalid,
.passwordLogin .passwordLogin .el-message-box__input input.invalid:focus {
  border-bottom: 1px solid #f56c6c !important;
}

.passwordLogin .div_view {
  position: relative;
}

.gula_view .el-button.is-circle {
  padding: 6px !important;
}

.gula_view .iconfont {
  font-size: 24px;
}

.passwordLogin .div_ab {
  position: absolute;
  font-size: 16px;
  right: 0;
  top: 0;
  color: #666666;
  cursor: pointer;
}

.gula_view .wrapper_flex {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.gula_view .wrapper_li {
  display: flex;
  align-items: center;
}

.wrapper_text {
  cursor: pointer;
  font-size: 16px;
}

.gula_view .wrapper_tips {
  margin-top: 18px;
}

.wrapper_code_view {
  background: #FFFFFF;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wrapper_code_top {
  /* width: 100%; */
  height: 40px;
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.wrapper_code_top > .title {
  color: #666666;
}

.wrapper_cont_top {
  color: #333333;
}

.wrapper_wrapper_cont_img {
  width: 216px;
  height: 216px;
  margin-top: 20px;
  position: relative;
}

.wrapper_wrapper_cont_img > .title {
  width: 216px;
  height: 216px;
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  top: 0;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.wrapper_cont_top_tips {
  cursor: pointer;
  margin-top: 20px;
}

.wrapper_code_login {
  margin-top: 24px;
  text-align: center;
  font-size: 16px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: #333333;
  cursor: pointer;
}

.el-form-item {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/LoginBox/index.vue